import { http } from '@/providers/apis/http';
import { LibrariesSerializer, librariesSerializer } from '@/providers/serializers/libraries/libraries';

export class LibrariesAPI {
    private static INSTANCE = new LibrariesAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/nucleus/v2/libraries';

    public fetchLibraries(status: any = {}) {
        const endpoint = this.namespace;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, status).then((response) => {
            return librariesSerializer.normalizeLibraries(response.data);
        });

    }

}

export const librariesAPI = LibrariesAPI.instance;
